// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"08ac10c6","238":"a0ebab55","239":"166d2b8b","316":"20d77fb1","557":"4ee9279d","667":"fbda9eb6","762":"96e38db3"}[chunkId] + ".chunk.js";
};